/** 操作表单字段定义（与 ActionForm 的 fields 同形）。 */
export interface ActionField {
  name: string;
  label: string;
  type?: string;
  required?: boolean;
  options?: string[];
}

/**
 * 把表单取值整理成请求体：勾选框字段一律发真布尔（未勾即 false），
 * 不发字符串 "false"——后端只认 JSON 布尔（#4748）。其它字段原样保留。
 */
export function actionPayload(
  fields: readonly ActionField[],
  values: Record<string, string | boolean>,
): Record<string, string | boolean> {
  const body: Record<string, string | boolean> = { ...values };
  for (const field of fields) {
    if (field.type === "checkbox") body[field.name] = values[field.name] === true;
  }
  return body;
}
